import { store } from '@/app/shared/stores';

class CachedGiftCardContentClass {
  constructor() {
    async function updateIfNeeded() {
      const threeMinutesInSeconds = 180;
      if (
        store.state.content.lastGiftCardFetch === undefined
        || (new Date() - new Date(store.state.content.lastGiftCardFetch)) / 1000
          > threeMinutesInSeconds
      ) {
        await store.dispatch('updateGiftCardContent');
      }
    }

    this.getBannerImage = async () => {
      await updateIfNeeded();
      return store.state.content.giftCardBannerImage;
    };

    this.getBannerText = async () => {
      await updateIfNeeded();
      return store.state.content.giftCardBannerText;
    };

    this.getMembershipText = async () => {
      await updateIfNeeded();
      return store.state.content.giftCardMembershipText;
    };

    this.getExperienceText = async () => {
      await updateIfNeeded();
      return store.state.content.giftCardExperienceText;
    };

    this.getCustomText = async () => {
      await updateIfNeeded();
      return store.state.content.giftCardCustomText;
    };
  }
}

const CachedGiftCardContentService = new CachedGiftCardContentClass();

export { CachedGiftCardContentService };
